import { render, staticRenderFns } from "./ConnectionGroup.vue?vue&type=template&id=1ffcea35&"
import script from "./ConnectionGroup.vue?vue&type=script&lang=ts&"
export * from "./ConnectionGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectionGroup.vue?vue&type=style&index=0&id=1ffcea35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports